module.exports = __webpack_public_path__ + "img/ebqlogo.9301c87.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/web/ebqlogo.png
// module id = NC4y
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37